import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=0e9a474c&lang=pug&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9a474c')) {
      api.createRecord('0e9a474c', component.options)
    } else {
      api.reload('0e9a474c', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=0e9a474c&lang=pug&", function () {
      api.rerender('0e9a474c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contact.vue"
export default component.exports